var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.AnalyticsSubPage,{attrs:{"title":"Education Analytics","icon":"graduation-cap","css-class":"analytics-education","default-label":"Education","section-specs":_setup.sectionSpecs}},[_c(_setup.CoachMetrics,{ref:"coachRef"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }